import { render, staticRenderFns } from "./HrFilesTable.vue?vue&type=template&id=0d6d3330&scoped=true"
import script from "./HrFilesTable.vue?vue&type=script&lang=js"
export * from "./HrFilesTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d6d3330",
  null
  
)

export default component.exports